import { render, staticRenderFns } from "./PracticeFindLocumCard.vue?vue&type=template&id=67a208fc&scoped=true&"
import script from "./PracticeFindLocumCard.vue?vue&type=script&lang=js&"
export * from "./PracticeFindLocumCard.vue?vue&type=script&lang=js&"
import style0 from "./PracticeFindLocumCard.vue?vue&type=style&index=0&id=67a208fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a208fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VImg,VRow})
